export const STEP_MS = 3300;
export const MAX_PROGRESS = 92;

export const STYLES = [
  { id: "dark", label: "Sombre", url: "mapbox://styles/mapbox/dark-v11" },
  { id: "light", label: "Clair", url: "mapbox://styles/mapbox/light-v11" },
  { id: "streets", label: "Routière", url: "mapbox://styles/mapbox/streets-v12" },
  { id: "satellite", label: "Satellite", url: "mapbox://styles/mapbox/satellite-streets-v12" },
  { id: "outdoors", label: "Courbes de niveau", url: "mapbox://styles/mapbox/outdoors-v12" },
  { id: "navigation", label: "Navigation", url: "mapbox://styles/mapbox/navigation-night-v1" },
];
export const MIN_PANEL = 660; 
export const MAX_RATIO = 0.9;
export const PITCH_STEP = 10;
export const PITCH_MAX = 60;
export const MAX_SELECTED = 20;

export const ALL_VISIBLE = {
  real: true,
  sim: true,
  zone: true,
  saved: true,
  burned: true,
};